import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import InputText from './../../components/input/InputText';
import InputDropDownList from './../../components/input/InputDropDownList';
import InputCheckBox from './../../components/input/InputCheckBox';
import EditForm from '../../components/form/EditForm';
import { useErrorContext } from '../../components/messages/ErrorBox';
import InputRadioButtons from 'components/input/InputRadioButtons';
import EditFormFieldTable from 'components/form/EditFormFieldTable';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import Table from 'jsx/elements/tables/Table';



const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TransactionKeyEdit = () => {
  //Some helpers.
  const params = new URLSearchParams(useLocation().search);
  const navigator = useHistory();
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  //Init blank formdata record.
  const [formData, setFormData] = useState({
    transactionKeyID: 0,
    isNew: true,
    vatDisabled: false,
    penaltyInterestDisabled: false
  });

  const [workingData, setWorkingData] = useState({
    transactionKeyID: 0,
    key: "",
    name: "",
    transactionGroupID: null,
    calculateVAT: false,
    calculateInterest: false,
    transactionOwnerTypeID: 1,
    transactionCategoryTypeID: 2,
    transactionNatureTypeID: 2,
    accountingKey: null,
    balanceKey: null,
    depositClassID: 1,
    excludeFromJudgmentCost: false
  });

  const [lookupData, setLookupData] = useState({
    transactionGroupList: [],
    ownerTypeList: [],
    categoryTypeList: [],
    natureTypeList: [],
    depositClassList: [],
  });


 /* const isResultOk = (obj) => {
    console.log("isresultOK", obj);
    if ((obj != null) && (obj.error != undefined)) {
      setCheckErrorItems([obj]);
      return false;
    }else
    return true;
  }*/

  const loadLookupData = async () => {
    //Load all the data at the same time.     
    let [transactionGroupList, ownerTypeList, categoryTypeList, natureTypeList, depositClassList] = await Promise.all([
      apiGetCall(BASE_URL + '/admin/list/transactionkeygroup'),
      apiGetCall(BASE_URL + '/admin/list/transactionkey/ownertype'),
      apiGetCall(BASE_URL + '/admin/list/transactionkey/categorytype'),
      apiGetCall(BASE_URL + '/admin/list/transactionkey/naturetype'),
      apiGetCall(BASE_URL + '/admin/list/depositclass'),
    ]);
    //Check we need to display any critical errors.
    setCheckErrorItems([transactionGroupList, ownerTypeList, categoryTypeList, natureTypeList,depositClassList]);

    //Translate the data into what we want to use.
    setLookupData({
      transactionGroupList: transactionGroupList,
      ownerTypeList: ownerTypeList,
      categoryTypeList: categoryTypeList,
      natureTypeList: natureTypeList,
      depositClassList: depositClassList,
    });
  }

  const loadFormData = async () => {
    setIsPageLoading(true);
    let newFormData = { ...formData };
    //console.log("load");
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let transactionKeyID = params.get("transactionkeyid");
    let isNew = params.get("newkey");
    //console.log(transactionKey, isNew);
    if (transactionKeyID == null || transactionKeyID <= 0) {
      if (isNew == null) {
        navigator.push("/admin/transactionkeys");
      }
    }

    //Check if we have new item or old item.  
    let transactionKey = null;
    if (transactionKeyID) {
      newFormData.isNew = false;
      newFormData.transactionKeyID = transactionKeyID;
      transactionKey = await apiGetCall(BASE_URL + '/admin/transactionkey/' + newFormData.transactionKeyID);
      if (isResultOk(transactionKey)) {
       // console.log("workingdata", transactionKey);
        setWorkingData(transactionKey);
      }
    }

    //Lookup data.
    await loadLookupData();

    setFormData(newFormData);

    if (transactionKey) {
      //onMatrixChange("owner", transactionKey.transactionOwnerTypeID);
    }

    setIsPageLoading(false);
  }


  useEffect(() => {
    loadFormData();
  }, []);


  const onSaveClick = async () => {
    setIsPageLoading(true);
    let requestResult = null;
 //   if (1 != 1) {
      if (!formData.isNew) {
        requestResult = await apiPostCall(BASE_URL + '/admin/transactionkey/change', workingData);
      }
      else {
        if(workingData.transactionCategoryTypeID != "2"){
          workingData.transactionNatureTypeID = null;
        }
        requestResult = await apiPostCall(BASE_URL + '/admin/transactionkey/create', workingData);
      }
 //   }
    if (isResultOk(requestResult, setCheckErrorItems)) {
      goBack();
    }
    setIsPageLoading(false);
  }



 // function handleResponse(res, newName, newGroupKey) {
 //   const messageBoxText = newName ? "BREYTING TÓKST" : "NÝSKRÁNING TÓKST";
 //   if (res && res.error) {
 //     triggerMessageBox(res.error.message, "error");
 //   }
 //   else {
 //     triggerMessageBox(messageBoxText, "success");
 //     goBack();
 //     //setName("");
 //     //setGroupKey("");
 //     /* if (newName) {
 //        setPlaceholderName(newName);
 //        setPlaceholderGroupKey(newGroupKey);
 //      }*/
 //   }
 // }



  const transactionRestriction =
    [
      [ //Logmaður
        {   //hofudstoll
          disabled: true,
          cost: null
        },
        {  // Kostnaður
          disabled: false,
          cost: 1,
          tax: [
            {
              disabled: false,
              isChecked: true
            },
            {
              disabled: false,
              isChecked: true
            }
          ]
        },
        {   //Innborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //Útborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //afslattur
          disabled: false,
          cost: null,
          tax: null,
        }
      ],
      [ //Krofuhafi
        {  // hofudstoll
          disabled: false,
          cost: null,
          tax: [
            {
              disabled: true,
              isChecked: false
            },
            {
              disabled: false,
              isChecked: true
            }
          ]
        },
        {   //Kostnaður
          disabled: false,
          cost: null,
          tax: [
            {
              disabled: false,
              isChecked: false
            },
            {
              disabled: false,
              isChecked: false
            }
          ]
        },
        {   //Innborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //Útborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //afslattur
          disabled: false,
          cost: null,
          tax: null,
        }
      ],
      [ //Skuldari
        {   //hofudstoll
          disabled: true,
          cost: null,
          tax: null,
        },
        {   //Kostnaður
          disabled: true,
          cost: null,
          tax: null,
        },
        {   //Innborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //Útborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //afslattur
          disabled: true,
          cost: null,
          tax: null,
        }
      ],
      [ //Ríkið
        {   //hofudstoll
          disabled: true,
          cost: null,
          tax: null,
        },
        {   //Kostnaður
          disabled: true,
          cost: null,
          tax: null,
        },
        {   //Innborgun
          disabled: true,
          cost: null,
          tax: null,
        },
        {   //Útborgun
          disabled: false,
          cost: null,
          tax: null,
        },
        {   //afslattur
          disabled: true,
          cost: null,
          tax: null,
        }
      ]
    ];



  function setCategory(ownerTypeID, list) {
    if (list) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index];
        item.disabled = transactionRestriction[ownerTypeID - 1][index].disabled;
      }
    }
  }

  const setNatureType = (ownerTypeID, categoryTypeID, list) => {
    list.forEach(item => {
      item.data.disabled = categoryTypeID != 2 ? true : transactionRestriction[ownerTypeID - 1][categoryTypeID - 1].cost == null;
    });
  }

  const goBack = () => {
    navigator.push("/admin/transactionkeys");
  }

  const setTax = (ownerTypeID, categoryTypeID, formdata, workingData) => {
    if (transactionRestriction[ownerTypeID - 1][categoryTypeID - 1].tax != null) {
      formdata.vatDisabled = transactionRestriction[ownerTypeID - 1][categoryTypeID - 1].tax[0].disabled;
      formdata.penaltyInterestDisabled = transactionRestriction[ownerTypeID - 1][categoryTypeID - 1].tax[1].disabled;
    } else {
      formdata.vatDisabled = false;
      formdata.penaltyInterestDisabled = false
      workingData.calculateVAT = false;
      workingData.calculateInterest = false;
    }
  }

  const onMatrixChange = (type, value) => {
    let newWorkData = { ...workingData };
    let newFormData = { ...formData };
    let newLookupData = { ...lookupData };
    if (type === "owner") {
      newWorkData = { ...workingData, transactionOwnerTypeID: value };
    } else if (type === "category") {
      newWorkData = { ...workingData, transactionCategoryTypeID: value };
    } else if (type === "nature") {
      newWorkData = { ...workingData, transactionNatureTypeID: value };
    }

    let categoryList = newLookupData.categoryList;
    let natureList = newLookupData.natureTypeList;

    setCategory(newWorkData.transactionOwnerTypeID, categoryList);
    setNatureType(newWorkData.transactionOwnerTypeID, newWorkData.transactionCategoryTypeID, natureList);
    setTax(newWorkData.transactionOwnerTypeID, newWorkData.transactionCategoryTypeID, newFormData, newWorkData);

    setLookupData(newLookupData);
    setFormData(newFormData);
    setWorkingData(newWorkData);
  }


  // const onSaveClick = () => {
  //  console.log("Save clicked in editform", this);
  //}

  const validateInput = () => {
    let messages = [];
    if (workingData.name === "") {
      messages.push("Vantar heiti á færslulykil");
    }
    if (workingData.key === "") {
      messages.push("Vantar númer á færslulykil");
    }
    if (workingData.key.length < 6) {
      messages.push("Lengd færslulykils verður að vera 6 stafir");
    }
    if (workingData.transactionGroupID == null || workingData.transactionGroupID <= 0) {
      messages.push("Vantar að velja færslulyklahóp");
    }
    return messages; //return list of messsages, if > 0 then onSaveClick is not activated.
  }


  //console.log("formData", formData);

  return (
    <EditForm newTitle="Nýr færslulykil" changeTitle="Breyta færslulykli" isNew={formData.isNew} onSubmitClick={onSaveClick} onValidate={validateInput}>
      <EditFormFieldTable fields={[
        {
          title: "Númer færslulykils",
          edit: () => (<InputText name="Key" value={workingData.key} maxLength="6" onChange={(value) => setWorkingData({ ...workingData, key: value })} />)
        },
        {
          title: "Heiti færslulykils",
          edit: () => (<InputText name="name" value={workingData.name} onChange={(value) => setWorkingData({ ...workingData, name: value })} />)
        },
        {
          title: "Færslulyklahópur",
          edit: () => (<InputDropDownList
            name="TransactionGroup"
            list={lookupData.transactionGroupList}
            keyField="itemID"
            displayField={(item) => { return item.name + " " + (item.data ? "(" + item.data.key + ")" : ""); }}
            defaultValue={workingData.transactionGroupID}
            onChange={(value) => setWorkingData({ ...workingData, transactionGroupID: value })}
            nullable={true}
            nullableItem={{ itemID: null, name: "" }}
          />)
        }, {
          title: "Eigandi",
          edit: () => (<InputRadioButtons
            name="TransactionOwnerType"
            list={lookupData.ownerTypeList}
            defaultValue={workingData.transactionOwnerTypeID}
            keyField="itemID"
            displayField="name"
            onChange={(value) => setWorkingData({ ...workingData, transactionOwnerTypeID: value })}
          />)
        },
        {
          title: "Færsluflokkur",
          edit: () => (<InputRadioButtons
            name="TransactionCategoryType"
            defaultValue={workingData.transactionCategoryTypeID}
            keyField="itemID"
            displayField="name"
            list={lookupData.categoryTypeList}
            onChange={(value) => setWorkingData({ ...workingData, transactionCategoryTypeID: value })}
          />)
        },
        {
          title: "Eðli",
          edit: () => ( <InputRadioButtons
            name="TransactionNatureType"
            defaultValue={(workingData.transactionCategoryTypeID != 2) ? null : workingData.transactionNatureTypeID }
            keyField="itemID"
            displayField="name"
            list={lookupData.natureTypeList}
            onChange={(value) => setWorkingData({ ...workingData, transactionNatureTypeID: value })}
            itemDisabled={(item) => { return item.data.disabled; }}
            disabled={workingData.transactionNatureTypeID == null || workingData.transactionCategoryTypeID != 2}
          />)
        },
        {
          title: "Reikniforsendur",
          edit: () => (<div>
            <InputCheckBox name="calculateVAT" value={workingData.calculateVAT} label="Reikna virðisaukaskatt" disabled={formData.vatDisabled} onChange={(value) => setWorkingData({ ...workingData, calculateVAT: value })} />
            <InputCheckBox name="calculateInterest" value={workingData.calculateInterest} label="Reikna dráttarvexti" disabled={formData.penaltyInterestDisabled} onChange={(value) => setWorkingData({ ...workingData, calculateInterest: value })} />
            <div style={{ display: (workingData.transactionNatureTypeID == 2) ? 'block' : 'none' }}><InputCheckBox name="excludeJudgementCost" value={workingData.excludeFromJudgmentCost} label="Ekki reikna í dæmdan málskostnað" disabled={formData.excludeFromJudgmentCost} onChange={(value) => setWorkingData({ ...workingData, excludeFromJudgmentCost: value })} /></div>
          </div>)
        },
        {
          title: "Account key",
          edit: () => (<InputText name="accountingKey" value={workingData.accountingKey} onChange={(value) => setWorkingData({ ...workingData, accountingKey: value })} />)
        },
        {
          title: "Balance key",
          edit: () => (<InputText name="balanceKey" value={workingData.balanceKey} onChange={(value) => setWorkingData({ ...workingData, balanceKey: value })} />)
        },
      ]} />

<div style={{ display: (workingData.transactionCategoryTypeID == 3) ? 'block' : 'none' }}>
<EditFormFieldTable fields={[ {
          title: "Innborgunar flokkun",
          edit: () => (<InputRadioButtons
            name="DepostiClass"
            defaultValue={workingData.depositClassID}
            keyField="itemID"
            displayField="name"
            list={lookupData.depositClassList}
            onChange={(value) => setWorkingData({ ...workingData, depositClassID: value })}
          />)},
          {
            title: "Flokkar",
            edit: () => (
              <Table
          cols={['35%', '']}
          head={[
            'Flokkur',
            'Lýsing'
          ]}
          hover="true"
        >
          {lookupData.depositClassList.map((item, index) => 
            <tr key={index}>
              <td>
                {item.name}
              </td>
              <td>
                {item.data.description}
              </td>
            </tr>
          )} 
        </Table>
            )
          },
        ]} />
      </div> 
    </EditForm>
  );
}

